/**
 * useStudentAccountData — « Mon compte » relit le compte et ses quêtes à l'ouverture.
 *
 * Les deux lectures de l'ancien « tirer pour rafraîchir » (`MyAccountScreen.js` : `getUser` et
 * `getSkillSets`), que la page du design system n'a pas : elles partent une fois, à l'ouverture.
 * Leurs réponses arrivent dans `currentUser` (patron A) : le view-model les lit de là, et rien ne
 * se consomme ici. Les deux tranches sont aussi lues par la coquille : on ne les rend pas au repos.
 */
import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { skillSetsService } from "../../../../../../data/services/skillSetsService"

export function useStudentAccountData(): void {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(apiRequest(authService.getUser) as never)
        dispatch(apiRequest(skillSetsService.getSkillSets) as never)
    }, [dispatch])
}
